import React from 'react';
import {Link} from 'react-router-dom'

const e = React.createElement;


function Login() {}
Login.prototype = Object.create(React.Component.prototype);


Login.prototype.render = function() {
  var tr_email = "E-mail";
  var tr_pass = "Wachtwoord";
  var tr_login = "inloggen";
  var tr_forgot = "Wachtwoord vergeten?";
  var tr_register = "Nog geen account? Registreer nu!";

  if(this.props.language === "EN") {
    tr_email = "Email";
    tr_pass = "Password";
    tr_login = "login";
    tr_forgot = "Forgot your password?";
    tr_register = "No account yet? Register here!";
  }

  return e('div', null, [
    e('form', {key:"1", onSubmit:this.props.handleLogin}, [
      e('div', {key:"11"}, e('input', {type:"text", value:this.props.email, onChange:this.props.handleChange.bind(this, "email"), placeholder:tr_email, autoFocus:true})),
      e('div', {key:"12"}, e('input', {type:"password", value:this.props.password, onChange:this.props.handleChange.bind(this, "password"), placeholder:tr_pass})),
      e('div', {key:"13"}, e('input', {type:"submit", value:tr_login, disabled:this.props.login_is_fetching})),
    ]),
    e('div', {key:"2", className:"footnote"}, e(Link, {to:"/", onClick:this.props.switchContent.bind(this, "recover")}, tr_forgot)),
    e('div', {key:"3", className:"footnote"}, e(Link, {to:"/", onClick:this.props.switchContent.bind(this, "register")}, tr_register)),
  ]);
}


export default Login



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount_Login.js
// module id = 230
// module chunks = 0